import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import State from '../State';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import CustomerUpdateRequested from '../events/CustomerUpdateRequested';
import CustomerUpdatedSucceed from '../events/CustomerUpdatedSucceed';
import RequestFailed from '../../core/events/RequestFailed';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(CustomerUpdateRequested.type),
        mergeMap((event: CustomerUpdateRequested) =>
            backend.patch(`${api()}customers/${event.id}`, JSON.stringify(event.customer)).pipe(
                map((ajaxResponse: AjaxResponse) => new CustomerUpdatedSucceed(event.id!, ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            )
        )
    );



// WEBPACK FOOTER //
// ./src/application/admin/epic/customerUpdate.ts